import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MediaModel } from '../../models/conversation-history.model';

@Component({
  selector: 'app-image-viewer-dialog',
  templateUrl: './image-viewer-dialog.component.html',
  styleUrls: ['./image-viewer-dialog.component.scss'],
  imports: [CommonModule]
})
export class ImageViewerDialogComponent {
  currentIndex: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: { images: MediaModel[], startIndex: number },
    private dialogRef: MatDialogRef<ImageViewerDialogComponent>
  ) {
    this.currentIndex = dialogData.startIndex;
  }

  get currentImage(): MediaModel {
    return this.dialogData.images[this.currentIndex];
  }

  next(): void {
    if (this.currentIndex < this.dialogData.images.length - 1) {
      this.currentIndex++;
    }
  }

  prev(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
